
(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "undefined";
              window.beaePageSetting.pageTitle = "Contact Oma's Kitchen Support"; 
              window.beaePageSetting.pageType = "page";

          let js_OVO9D9NV = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-2xuo0hv4section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2xuo0hv4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2xuo0hv4');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2xuo0hv4: ', ex)
      };
    

      try {
        let argid = 'beae-lzo9c148block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-lzo9c148',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-lzo9c148');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-lzo9c148: ', ex)
      };
    

      try {
        let argid = 'beae-u8av3w9jblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-u8av3w9j',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-u8av3w9j');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-u8av3w9j: ', ex)
      };
    

      try {
        let argid = 'beae-oix9zf65block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-oix9zf65',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-oix9zf65');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-oix9zf65: ', ex)
      };
    

      try {
        let argid = 'beae-lc64jc5zsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-lc64jc5z',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-lc64jc5z');
        args.el = args.els[0];
        ((g) => { window.BeaeSlider&&!g.noRunJs&&window.BeaeSlider(g) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-lc64jc5z: ', ex)
      };
    

      try {
        let argid = 'beae-s0923r9dblock-form',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-s0923r9d',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-s0923r9d');
        args.el = args.els[0];
        ((h) => { const g=window.location.href.indexOf("contact_posted=true")!==-1,u=h.el.querySelector("form");h.el.querySelector(".beae-btn-pr");const f=h.el.querySelectorAll("input","select","button","textarea","checkbox","radio"),b=h.el.querySelector(".btn-lightbox-form > button");!g&&h.mode.value!=="builder"&&(h.el.querySelector(".beae-form-success-message").style="display: none"),g&&h.afterSubmitting=="redirect"&&h.redirect&&(h.el.querySelector(".beae-form-success-message").style="display: block",window.location.href=h.redirect);const k=[];u&&u.addEventListener("submit",m=>{m.preventDefault();for(let y=0;y<f.length;y++)k.push({fieldKey:f[y].name,fieldType:f[y].type,fieldValue:f[y].value})}),b&&(b.onclick=()=>{const m=document.createElement("div");m.innerHTML=u.outerHTML||"",window.BeaePopupLibrary.createPopup(m,{layout:"center",layoutMobile:"bottom",width:"500px",id:h.id})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-s0923r9d: ', ex)
      };
    }; if (window.BEAEBASE) {js_OVO9D9NV()} else {window.BEAEPAGEJS.push(js_OVO9D9NV)} })(); 